import { render, staticRenderFns } from "./electronicsMarket.vue?vue&type=template&id=a4c0701a&scoped=true"
import script from "./electronicsMarket.vue?vue&type=script&lang=js"
export * from "./electronicsMarket.vue?vue&type=script&lang=js"
import style0 from "./electronicsMarket.vue?vue&type=style&index=0&id=a4c0701a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c0701a",
  null
  
)

export default component.exports